import { Box, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import VariationContentPiecesService from "../../services/variation-content-pieces.service";
import VariationCard from "../../views/variation-card/VariationCard";
import useUser from "../../hooks/useUser";
import SortVariationsHelper from '../../helpers/sort-variation.helper';
import { Statuses } from "../../enums/Statuses";
import Ghost from "../../views/ghost/Ghost";
import { GhostTemplates } from "../../enums/GhostTemplates";
import VariationTipCard from "../../views/variation-tip-card/VariationTipCard";
import { AllVariations } from "../../type/AllVariations";
import { VariationType } from "../../enums/VariationType";
import { VariationExtended } from "../../interfaces/VariationExtended";
import { VariationTipExtended } from "../../interfaces/VariationTipExtended";

const MyVariations = () => {
  const [variations, setVariations] = useState<AllVariations[]>([]);
  const [status, setStatus] = useState<Statuses>(Statuses.IDLE);
  const { showBoundary } = useErrorBoundary();
  const user = useUser();

  useEffect(() => {
    const abortController = new AbortController();
    if (user?.email) {
      setStatus(Statuses.PENDING);
      VariationContentPiecesService.getByUserEmail(user.email)
        .then((variations) => {
          setVariations(SortVariationsHelper.sortAllVariationsByDatetime(variations));
          setStatus(Statuses.SUCCESS);
        })
        .catch((error: Error) => {
          showBoundary(error);
          setStatus(Statuses.ERROR);
        })
        .finally(() => setStatus(Statuses.IDLE));
    }

    return () => abortController.abort();
  }, [user, showBoundary])

  return <>
    <Typography className='h3 pt-2 pb-4 ps-2'>
      Your variations:
    </Typography>
    {status === Statuses.PENDING ?
      <Ghost template={GhostTemplates.VARIATION_CARD} repeatValue={5} />
      :
      <>
        {variations.length > 0 ? variations.map((variation) => {
          return (
            <Box key={variation.id}>
              {variation.attributes?.source  === VariationType.TIP ? <VariationTipCard variation={variation as VariationTipExtended} showUser={false} /> :
                <VariationCard variation={variation as VariationExtended} image='' />
              }
            </Box>
          );
        })
          :
          <Typography className='pt-2 ps-2 h5' align='center'>
            You have no variations created
          </Typography>}
      </>
    }
  </>
}

export default MyVariations;
